import {
  LightBulbIcon, DocumentTextIcon, CurrencyDollarIcon, BuildingOffice2Icon, 
  ArrowPathIcon, AcademicCapIcon, UserIcon, UsersIcon, RocketLaunchIcon, 
  Cog6ToothIcon, SparklesIcon
} from '@heroicons/react/24/outline';

export const MEMBERSHIP_HOPES = [
  { id: 'career', label: 'Discover modern, relevant L&D opportunities', icon: AcademicCapIcon },
  { id: 'tools', label: 'Access proven playbooks and guides to solve problems faster', icon: DocumentTextIcon },
  { id: 'savings', label: 'Find trusted HR tech and service partners faster', icon: CurrencyDollarIcon },
  { id: 'refresh', label: 'Stay in the loop with what the best People teams are doing right now', icon: ArrowPathIcon },
];

export const PEOPLE_CONTEXT = [
  { id: 'starting', label: "I'm just starting out in a People role", icon: SparklesIcon },
  { id: 'solo', label: "I'm a solo People/HR lead", icon: UserIcon },
  { id: 'scaling', label: "We're scaling fast and need structure", icon: RocketLaunchIcon },
  { id: 'modernizing', label: "We're established but modernising", icon: Cog6ToothIcon },
];

export const COMMON_COUNTRIES = [
  { code: 'GB', label: 'U.K', flag: '🇬🇧' },
  { code: 'IE', label: 'Ireland', flag: '🇮🇪' },
  { code: 'NA', label: 'North America', flag: '🌎' },
  { code: 'EU', label: 'Europe', flag: '🇪🇺' },
  { code: 'APAC', label: 'Asia Pacific', flag: '🌏' },
  { code: 'LATAM', label: 'Latin America', flag: '🌎' },
  { code: 'MEA', label: 'Middle East', flag: '🌍' },
  { code: 'AFRICA', label: 'Africa', flag: '🌍' },
  { code: 'OTHER', label: 'Other', flag: '🌐' },
]; 

export const COMPANY_SIZE = [
  { id: '1-10', label: '1-10 employees', icon: UserIcon },
  { id: '11-50', label: '11-50 employees', icon: UsersIcon },
  { id: '51-200', label: '51-200 employees', icon: BuildingOffice2Icon },
  { id: '201-1000', label: '201-1000 employees', icon: BuildingOffice2Icon },
  { id: '1001+', label: '1001+ employees', icon: BuildingOffice2Icon },
]